// extracted by mini-css-extract-plugin
export default {"tabContent":"tab-contnet_tabContent__we6RV"};